/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Datum } from './datum';

export interface RoleResultData { 
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    hasPrevious?: boolean;
    hasNext?: boolean;
    data?: Array<Datum>;
}